import { render, staticRenderFns } from "./PorletListado.vue?vue&type=template&id=303fa8c6"
import script from "./PorletListado.vue?vue&type=script&lang=js"
export * from "./PorletListado.vue?vue&type=script&lang=js"
import style0 from "./PorletListado.vue?vue&type=style&index=0&id=303fa8c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports